import * as dom from './wpstg-dom-utils.js';

/**
 * Rich Exclude Filter Module
 */
export default class WpstgExcludeFilters {
  constructor(
      excludeFilterContainerSelector = '#wpstg-exclude-filters-container',
      wpstgObject = wpstg,
  ) {
    this.excludeContainer = dom.qs(excludeFilterContainerSelector);
    this.excludeTableBody = dom.qs(`${excludeFilterContainerSelector} tbody`);
    this.wpstgObject = wpstgObject;
    this.init();
  }

  addEvents() {
    dom.addEvent(this.excludeContainer, 'click', '.wpstg-file-size-rule', () => {
      this.addFileSizeExclude();
    });

    dom.addEvent(this.excludeContainer, 'click', '.wpstg-file-ext-rule', () => {
      this.addFileExtExclude();
    });

    dom.addEvent(this.excludeContainer, 'click', '.wpstg-file-name-rule', () => {
      this.addFileNameExclude();
    });

    dom.addEvent(this.excludeContainer, 'click', '.wpstg-dir-name-rule', () => {
      this.addDirNameExclude();
    });

    dom.addEvent(this.excludeContainer, 'click', '.wpstg-clear-all-rules', () => {
      this.clearExcludes();
    });

    dom.addEvent(this.excludeContainer, 'click', '.wpstg-remove-exclude-rule', (target) => {
      this.removeExclude(target);
    });
  }

  init() {
    if (this.excludeContainer === null) {
      console.log('Error: Given table selector not found!');
      return;
    }

    this.addEvents();
  }

  addFileSizeExclude() {
    this.addExcludeRuleRow('#wpstg-file-size-exclude-filter-template');
  }

  addFileExtExclude() {
    this.addExcludeRuleRow('#wpstg-file-ext-exclude-filter-template');
  }

  addFileNameExclude() {
    this.addExcludeRuleRow('#wpstg-file-name-exclude-filter-template');
  }

  addDirNameExclude() {
    this.addExcludeRuleRow('#wpstg-dir-name-exclude-filter-template');
  }

  addExcludeRuleRow(templateName) {
    const excludeRowTemplate = dom.qs(templateName);
    if (excludeRowTemplate !== null) {
      const clone = excludeRowTemplate.content.cloneNode(true);
      const excludeRow = clone.querySelector('tr');

      this.excludeTableBody.appendChild(excludeRow);
      dom.all('.wpstg-has-exclude-rules').forEach((e) => {
        e.style.display = 'inherit';
      });
    }
  }

  clearExcludes() {
    this.excludeTableBody.innerHTML = '';
    dom.all('.wpstg-has-exclude-rules').forEach((e) => {
      e.style.display = 'none';
    });
  }

  removeExclude(target) {
    if (target.parentElement !== null && target.parentElement.parentElement !== null) {
      this.excludeTableBody.removeChild(target.parentElement.parentElement);
    }

    if (this.excludeTableBody.innerHTML.trim() === '') {
      dom.all('.wpstg-has-exclude-rules').forEach((e) => {
        e.style.display = 'none';
      });
    }
  }

  /**
   * Converts all the exclude filters arrays into one single string to keep size of post request small
   * @return {string}
   */
  getExcludeFilters() {
    const globExcludes = [];
    const sizeExcludes = [];

    const sizeCompares = this.excludeTableBody.querySelectorAll('select[name="wpstgFileSizeExcludeRuleCompare[]"]');
    const sizeSizes = this.excludeTableBody.querySelectorAll('input[name="wpstgFileSizeExcludeRuleSize[]"]');
    const sizeByte = this.excludeTableBody.querySelectorAll('select[name="wpstgFileSizeExcludeRuleByte[]"]');
    for (const [key, sizeInput] of Object.entries(sizeSizes)) {
      if (sizeInput.value !== '') {
        sizeExcludes.push(sizeCompares[key].value + ' ' + sizeInput.value + sizeByte[key].value);
      }
    }

    const extensionInputs = this.excludeTableBody.querySelectorAll('input[name="wpstgFileExtExcludeRule[]"]');
    extensionInputs.forEach((x) => {
      const ext = this.cleanStringForGlob(x.value);
      if (ext !== '') {
        globExcludes.push('ext:' + ext.trim());
      }
    });

    const fileNamesPos = this.excludeTableBody.querySelectorAll('select[name="wpstgFileNameExcludeRulePos[]"]');
    const fileNames = this.excludeTableBody.querySelectorAll('input[name="wpstgFileNameExcludeRulePath[]"]');
    for (const [key, fileInput] of Object.entries(fileNames)) {
      const fileName = this.cleanStringForGlob(fileInput.value);
      if (fileName !== '') {
        globExcludes.push('file:' + fileNamesPos[key].value + ' ' + fileName.trim());
      }
    }

    const dirNamesPos = this.excludeTableBody.querySelectorAll('select[name="wpstgDirNameExcludeRulePos[]"]');
    const dirNames = this.excludeTableBody.querySelectorAll('input[name="wpstgDirNameExcludeRulePath[]"]');
    for (const [key, dirInput] of Object.entries(dirNames)) {
      const dirName = this.cleanStringForGlob(dirInput.value);
      if (dirName !== '') {
        globExcludes.push('dir:' + dirNamesPos[key].value + ' ' + dirName.trim());
      }
    }

    return {
      'sizes': sizeExcludes.filter(this.onlyUnique).join(','),
      // return set of unique rules
      'globs': globExcludes.filter(this.onlyUnique).join(','),
    };
  }

  onlyUnique(value, index, self) {
    return self.indexOf(value) === index;
  }

  /**
   * Remove most of the comment glob characters from the string
   * @param {String} value
   * @return {String}
   */
  cleanStringForGlob(value) {
    // will replace character like * ^ / \ ! ? [ from the string
    return value.replace(/[*^//!\.[?]/g, '');
  }
}
